import { createSlice } from '@reduxjs/toolkit'

import {
	createActions,
	initialStateTemplate,
	reducers,
} from '.reducers/libraries/filters.template'

const initialState = {
	name: '',
	...initialStateTemplate,
}

const libMusicFilters = createSlice({
	name: 'LIB/MUSIC/FILTERS',
	initialState,
	reducers: {
		...reducers,
	},
})

export const {
	setCurrentPage,
	setIsOpen,
	setPerPage,
	setOrder,
	setSortBy,
	resetLastUpdate,
	setCompanyId,
	setTagFilter,
	setKeywordsFilter,
	setPublicLink,
	setTagsFilter,
	resetTagsFilter,
	setInitialState,
	toggleFavorites,
	setSearchTerm,
	unsetTagFilters,
	toggleAllFavorites,
	setClientProvidedFilter,
	setBrandedFilter,
	clearTags,
} = createActions(libMusicFilters.name)

export default libMusicFilters.reducer
